
export const environment = {
  production: true,
  version: 'v.qa.2.13.4',
  login: 'https://wih39cmyk8.execute-api.us-east-1.amazonaws.com/qa/',
  urlCronEquipos: 'https://wih39cmyk8.execute-api.us-east-1.amazonaws.com/qa/crun/run',
  //urlEquipos: 'https://dedm8q2o4wuuo.cloudfront.net/web/equipos-v2-detalles',
  urlEquipos: 'https://wih39cmyk8.execute-api.us-east-1.amazonaws.com/qa/api/v1/equipo/cataloge',
  apikeyLogin: '8U9ezbHvfw5G4FX0ZnXvnRE0z5KKN5C5XaEOCna5',
  apikey: '8U9ezbHvfw5G4FX0ZnXvnRE0z5KKN5C5XaEOCna5',
  urlService: 'https://wih39cmyk8.execute-api.us-east-1.amazonaws.com/qa/administradorOfertas',
  keyRecapcha: ' ',
  nameurlLogin: 'loginMotorAdminPre',
  urlInventarioDat: 'https://dedm8q2o4wuuo.cloudfront.net/web/add-dat',
  urlInventarioDatGet: 'https://wih39cmyk8.execute-api.us-east-1.amazonaws.com/qa/api/v1/dat/list',
  urlInventarioDatDelete: 'https://wih39cmyk8.execute-api.us-east-1.amazonaws.com/qa/api/v1/dat/onedelete',
  urlGenerarl: 'https://wih39cmyk8.execute-api.us-east-1.amazonaws.com/qa/api/v1/',
  tokenInvenatarioDat: '3e9d7b2a5f6c',
  oringeCatalogo:'f4c5fc98-8a84-47b4-b74d-95fd05fcc206',
  urlogin: {
    url: '',
    apikey: ''
  }
};
